import { BUTTON_PRESS, VIEW } from '@/utils/analytics'

const TEAM_STALE_WORK_BANNER = 'Team Stale Work Banner'

export const TEAM_STALE_WORK_ANALYTICS = {
  bannerClick: `${BUTTON_PRESS} ${TEAM_STALE_WORK_BANNER} - Open Modal`,
  bannerDismiss: `${BUTTON_PRESS} ${TEAM_STALE_WORK_BANNER} - Dismiss`,
  bannerView: `${VIEW} ${TEAM_STALE_WORK_BANNER}`,
  bulkResolveFailure: `${TEAM_STALE_WORK_BANNER} - Bulk Resolve - Failure`,
  bulkResolveSuccess: `${TEAM_STALE_WORK_BANNER} - Bulk Resolve - Success`,
  cardClick: `${BUTTON_PRESS} ${TEAM_STALE_WORK_BANNER} - Incident Card`,
  groupExpand: `${BUTTON_PRESS} ${TEAM_STALE_WORK_BANNER} - Expand Group`,
  loadMore: `${BUTTON_PRESS} ${TEAM_STALE_WORK_BANNER} - Load More`,
  resolveProgramClick: `${BUTTON_PRESS} ${TEAM_STALE_WORK_BANNER} - Resolve Program`,
  resolveSelectedClick: `${BUTTON_PRESS} ${TEAM_STALE_WORK_BANNER} - Resolve Selected`,
} as const

/** How long an acknowledged incident can sit unresolved before it is stale. */
export const STALE_THRESHOLD_HOURS = 1

/**
 * How long the X hides the banner (ENG-32181). Rolling and repeatable: each
 * dismissal writes a fresh `now + 24h` deadline, and snooze expiry is the
 * only thing that brings the banner back.
 */
export const STALE_SNOOZE_DURATION_MS = 24 * 60 * 60 * 1000

/**
 * localStorage key prefix for the persisted snooze deadline, suffixed with the
 * user id so a shared workstation doesn't inherit the previous operator's
 * snooze (ENG-32181).
 */
export const STALE_SNOOZE_STORAGE_KEY_PREFIX = 'staleBannerSnoozeUntil'

/**
 * Page size for the modal's server-aggregated group list (ENG-32213): one
 * request loads this many per-user group rows (user + count only), and
 * scrolling to the bottom of the modal pages in the next batch.
 */
export const TEAM_STALE_GROUPS_PAGE_SIZE = 50

/**
 * How many incidents' full details load per request when a group is expanded
 * (ENG-32130). Passed as `$last` to TeamStaleGroupIncidents so the server
 * pages each attributed user's incidents in chunks of this size (ENG-32213).
 */
export const TEAM_STALE_DETAILS_PAGE_SIZE = 50

/**
 * Page size for the program-wide resolve's id-only scan (ENG-32272): the
 * bulk resolve mutation requires explicit incident ids, so clicking
 * "resolve all" fetches every stale id sequentially in batches of this size.
 * Sized large because each row is a single id.
 */
export const TEAM_STALE_IDS_PAGE_SIZE = 500

/**
 * z-index for the floating selection ActionBar, chosen to sit above the dark
 * package Modal overlay, whose default is 1000 (packages/dark
 * Modal.styles.ts). If that default ever changes, this must move with it or
 * the bar silently drops behind the overlay.
 */
export const SELECTION_BAR_Z_INDEX = 1100

/**
 * Synthetic group id for stale incidents with neither owner nor guard
 * (acknowledged, then released). Distinctive enough to never collide with a
 * real user id.
 */
export const TEAM_STALE_UNASSIGNED_GROUP_ID = 'team-stale-unassigned'
